<template>
  <div>
    <search-nav @handleSearch="handleClickSearch">
      <search-nav-item-select name="year" label="연도" v-model="nav.searchYear" :list="selectYearOptions" />
      <search-nav-item-select name="type" label="구분" v-model="nav.searchType" :list="searchTypes" />
      <search-nav-item-select name="typefilter" label="" v-model="nav.searchTypeFilter" :list="searchTypeFilters" style="width: 300px !important" />
    </search-nav>
    <vx-card>
      <h5 class="mb-4"><i class="dot"></i> 위험성평가 위험도 세부 현황</h5>
      <!-- CONTENT -->
      <div class="content-container">
        <!-- HEAD -->
        <div class="flex items-center justify-start gap-2 mb-3">
          <vs-select autocomplete v-model="nav.perPage" style="width: 140px">
            <vs-select-item v-for="_perPage in perPageOpstions" :key="`perpage_${_perPage}`" :text="`${_perPage}개씩 보기`" :value="_perPage" />
          </vs-select>
          <FilterButton addFilterType="logical" :typeOptions="['기계공학과', '토목공학과', '건축공학과', '법학과', '특수학교', '각종학교', '본청', '직속(분원)', '교육지원청(공공도서관)']" :addOptions="filterBtnAddOptions" v-model="nav.filter" />

          <SearchNavItemKeyword :viewLabel="true" label="학교(기관)명" v-model="nav.searchKeyword" class="ml-auto" />
        </div>
        <!-- TABLE -->
        <vs-table :data="talbeDatas" pagination :max-items="nav.perPage">
          <template slot="thead">
            <vs-th sort-key="label"> 학교명 </vs-th>
            <vs-th sort-key="username"> 작업내용 </vs-th>
            <vs-th sort-key="id"> 위험도 </vs-th>
            <vs-th sort-key="id"> 평가일 </vs-th>
            <vs-th sort-key="id"> 작성자 </vs-th>
            <vs-th sort-key="id"> 문서상태 </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].label">
                {{ data[indextr].label }}
              </vs-td>
              <!-- <vs-td :data="data[indextr].username">
                {{ data[indextr].username }}
              </vs-td>
              <vs-td :data="data[indextr].id">
                {{ data[indextr].id }}
              </vs-td>
              <vs-td :data="data[indextr].id">
                {{ data[indextr].id }}
              </vs-td>
              <vs-td :data="data[indextr].id">
                {{ data[indextr].id }}
              </vs-td>
              <vs-td :data="data[indextr].id">
                {{ data[indextr].id }}
              </vs-td> -->
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import FilterButton from "./components/FilterButton/FilterButton.vue";
import ColorCircleData from "./components/ColorCircleData.vue";
import KPagination from "@/components/kPagination/kPagination";
import moment from "moment";

export default {
  components: {
    SearchNav,
    SearchNavItemSelect,
    SearchNavItemKeyword,
    FilterButton,
    ColorCircleData,
    KPagination,
  },
  data() {
    return {
      nav: {
        created_at: "",
        searchYear: moment().format("YYYY"),
        searchType: "",
        searchTypeFilter: "",
        searchKeyword: "",

        filter: [{ type: "type", value: ["기계공학과", "토목공학과", "건축공학과", "법학과", "특수학교", "각종학교", "본청", "직속(분원)", "교육지원청(공공도서관)"] }],

        perPage: 20,
        currentPage: 1,
        total: 100,
      },
      searchTypes: [{ value: "전체" }, { value: "반기" }, { value: "분기" }, { value: "월" }, { value: "일" }],
      filterBtnAddOptions: [
        { label: "작업내용", type: "input" },
        {
          label: "위험도",
          type: "selector",
          sub: [
            { label: "높음", color: "#EA5455" },
            { label: "약간높음", color: "#EA5455" },
            { label: "낮음", color: "#28C76F" },
          ],
        },
        { label: "평가일", type: "dateRang" },
      ],
      tabIndex: 0,
      talbeDatas: [],

      // API SAVE
      apiData: [],

      users: [
        {
          id: 1,
          name: "Leanne Graham",
          username: "Bret",
          email: "Sincere@april.biz",
          website: "hildegard.org",
        },
        {
          id: 2,
          name: "Ervin Howell",
          username: "Antonette",
          email: "Shanna@melissa.tv",
          website: "anastasia.net",
        },
        {
          id: 3,
          name: "Clementine Bauch",
          username: "Samantha",
          email: "Nathan@yesenia.net",
          website: "ramiro.info",
        },
        {
          id: 4,
          name: "Patricia Lebsack",
          username: "Karianne",
          email: "Julianne.OConner@kory.org",
          website: "kale.biz",
        },
        {
          id: 5,
          name: "Chelsey Dietrich",
          username: "Kamren",
          email: "Lucio_Hettinger@annie.ca",
          website: "demarco.info",
        },
        {
          id: 6,
          name: "Mrs. Dennis Schulist",
          username: "Leopoldo_Corkery",
          email: "Karley_Dach@jasper.info",
          website: "ola.org",
        },
        {
          id: 7,
          name: "Kurtis Weissnat",
          username: "Elwyn.Skiles",
          email: "Telly.Hoeger@billy.biz",
          website: "elvis.io",
        },
        {
          id: 8,
          name: "Nicholas Runolfsdottir V",
          username: "Maxime_Nienow",
          email: "Sherwood@rosamond.me",
          website: "jacynthe.com",
        },
        {
          id: 9,
          name: "Glenna Reichert",
          username: "Delphine",
          email: "Chaim_McDermott@dana.io",
          website: "conrad.com",
        },
        {
          id: 10,
          name: "Clementina DuBuque",
          username: "Moriah.Stanton",
          email: "Rey.Padberg@karina.biz",
          website: "ambrose.net",
        },
      ],
    };
  },
  computed: {
    // 선택 가능한 연도 값은 2020년부터 내년까지
    selectYearOptions() {
      const years = [];
      const startYear = 2020;
      const endYear = new Date().getFullYear() + 1;
      for (let i = startYear; i <= endYear; i++) {
        years.push(i);
      }
      return years.reverse().map((year) => ({ value: year }));
    },

    searchTypeFilters() {
      let returnData = [{ value: "전체" }];

      if (this.nav.searchType === "반기") returnData = [{ value: "상반기" }, { value: "하반기" }];
      else if (this.nav.searchType === "분기") returnData = [{ value: "1분기" }, { value: "2분기" }, { value: "3분기" }, { value: "4분기" }];
      else if (this.nav.searchType === "월") {
        // 1~12월
        const months = [];
        for (let i = 1; i <= 12; i++) {
          months.push(i);
        }
        returnData = months.map((month) => ({ value: `${month}월` }));
      } else if (this.nav.searchType === "일") {
        // 1~31일
        const days = [];
        for (let i = 1; i <= 31; i++) {
          days.push(i);
        }
        returnData = days.map((day) => ({ value: `${day}일` }));
      }

      if (returnData.length > 0) this.nav.searchTypeFilter = returnData[0].value;
      return returnData;
    },
    perPageOpstions() {
      return [20, 50, 100];
    },
  },
  created() {
    this.loadTableData();
  },
  methods: {
    // 검색 버튼 클릭
    handleClickSearch() {
      console.log("handleClickSearch");
    },
    // 탭 이동
    moveTab(data) {
      console.log(data);
    },
    async loadTableData() {
      const data = await this.$store.dispatch("summary/LOAD_FIELD_LIST_BY_POST_VALUE", {
        projectIds: [6],
        boardIds: [450],
        dateTarget: "content$body.inputB_4",
        valueTargets: ["body.riskAppraisalList[*].input_13"],
        valueOps: ["<="],
        values: ["C"],
      });
      this.apiData = data;

      this.setTableData();
    },
    setTableData() {
      this.talbeDatas = [];
      console.log(this.apiData, this.nav);

      // 선택한 연도의 데이터가 있으면
      if (this.apiData.fields[this.nav.searchYear]) {
        const yearData = this.apiData.fields[this.nav.searchYear];
        console.log("yearData", yearData);

        // 선택한 구분의 데이터가 있으면
        if (this.nav.searchType === "전체") {
          this.talbeDatas = yearData[0];

          console.log("talbeDatas", this.talbeDatas);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  th {
  }
}
</style>
